/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AgentTransactionType = "BUSINESS" | "REBALANCE" | "USER" | "%future added value";
export type UserInterface = "AGENT_PORTAL" | "API" | "AUTOMATIC" | "BUSINESS_PORTAL" | "CUSTOMER_APP_IOS" | "DISTRIBUTOR_APP" | "FRONTAPP" | "INTEGRATIONS_RECONCILIATION_PORTAL" | "KIOSK_NFC" | "KIOSK_QR" | "MERCHANT_QR" | "SLACK_TOOL" | "SMARTPHONE_APP" | "USSD" | "%future added value";
export type AgentTransactionInput = {
    amount: string;
    walletId?: string | null | undefined;
    userReference?: string | null | undefined;
    type?: AgentTransactionType | null | undefined;
    userInterface?: UserInterface | null | undefined;
    coords?: CoordinatesInput | null | undefined;
};
export type CoordinatesInput = {
    lng: number;
    lat: number;
    provider?: string | null | undefined;
    accuracy?: number | null | undefined;
};
export type AgentTransactionRebalanceDepositMutationVariables = {
    atx: AgentTransactionInput;
    userId: string;
    agentId: string;
    canReadBalance: boolean;
    canReadHistory: boolean;
    includeCancelled: boolean;
};
export type AgentTransactionRebalanceDepositMutationResponse = {
    readonly rebalanceDeposit: {
        readonly agentTransaction: {
            readonly id: string;
            readonly agentUser: {
                readonly " $fragmentRefs": FragmentRefs<"AgentTab_agentUser">;
            } | null;
        };
    } | null;
};
export type AgentTransactionRebalanceDepositMutation = {
    readonly response: AgentTransactionRebalanceDepositMutationResponse;
    readonly variables: AgentTransactionRebalanceDepositMutationVariables;
};



/*
mutation AgentTransactionRebalanceDepositMutation(
  $atx: AgentTransactionInput!
  $userId: ID!
  $agentId: ID!
  $canReadBalance: Boolean!
  $canReadHistory: Boolean!
  $includeCancelled: Boolean!
) {
  rebalanceDeposit(agentTransaction: $atx, agentUserId: $userId, agentId: $agentId) {
    agentTransaction {
      id
      agentUser {
        ...AgentTab_agentUser_4ErKPv
      }
    }
  }
}

fragment AgentHistoryAtxEntry_tx on AgentTransactionEntry {
  agentTransactionId
  currency
  isDeposit
  amount
  customerName
  customerMobile
  maybeTerminatedCustomerMobile
  agentId
  agentName
  agentUfid
  agentUserName
  subagentId
  subagentName
  subagentUfid
  type
  isBusinessWalletAtx
  merchantUfid
  merchantId
  walletAgentUfid
  walletAgentId
  isCancelled
  composingEntries {
    __typename
    amount
    summary
    isPending
    isCancelled
    whenEntered
    ... on AgentTransactionEntry {
      agentTransactionId
      isDeposit
    }
    id
  }
  relatedTicket {
    status
    slackMessageUrl
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...AgentHistoryEntry_entry
}

fragment AgentHistoryEntryDelegate_entry on HistoryEntry {
  __isHistoryEntry: __typename
  __typename
  ...AgentHistoryEntry_entry
  ...AgentHistoryAtxEntry_tx
}

fragment AgentHistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  id
  whenEntered
  amount
  balance
  summary
  isPending
  isCancelled
  ... on SupportHistoryEntry {
    __isSupportHistoryEntry: __typename
    scamInvestigationFields {
      deviceId
      deviceModel
      deviceName
      userInterface
      agentMobile
    }
  }
  ... on AgentTransactionEntry {
    agentTransactionId
  }
  ... on TransferSentEntry {
    transferId
  }
}

fragment AgentHistorySummary_summary on AgentDailySummary {
  date
  whenDayEnded
  dailyAward
  numSignups
  absoluteTransactionVolume
  effectiveTransactionVolume
  totalCommission
}

fragment AgentHistory_agent_1bayFN on Agent {
  id
  history(last: 30, includePending: true, includeCancelled: $includeCancelled) {
    edges {
      dailySummaries {
        whenDayEnded
        date
        totalCommission
        ...AgentHistorySummary_summary
      }
      node {
        __typename
        id
        whenEntered
        isCancelled
        ... on AgentTransactionEntry {
          agentTransactionId
          composingEntries {
            __typename
            ... on AgentTransactionEntry {
              agentTransactionId
            }
            id
          }
        }
        ...AgentHistoryEntryDelegate_entry
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}

fragment AgentTab_agentUser_4ErKPv on AgentUser {
  isActive
  ...ReportAgentIssue_agentUser
  ...ReportUserComplaint_agentUser
  ...AgentTransaction_agentUser
  ...CreateAgentAssistant_agentUser
  agent {
    id
    ufid
    name
    city
    subcity
    region
    isActive
    isReported
    isCompliant
    whenTerminated
    currency
    commissionStructureName
    commissionUrl
    principal {
      id
    }
    agentOnAgentGamingWatchlist {
      isOnList
      whenUpdated
    }
    agentOnAgentGamingWhitelist {
      isOnList
      whenUpdated
    }
    openingHoursDisplay(format: LONG)
    agentType
    recoveryBalance
    limitBalMin
    overdraftOffer {
      status
      id
    }
    subAgents {
      id
      ufid
      name
      agentType
    }
    managedByAgent {
      id
      ufid
      name
    }
    rebalanceNetworkHeadAgent {
      id
      ufid
      name
    }
    floatWallet {
      partnerOrg
      photoEditUrl
      id
      balance @include(if: $canReadBalance)
      mobile
      name
    }
    coords {
      lng
      lat
    }
    activeRebalanceLimit {
      rebalanceLimit
      whenActiveFrom
      whenActiveTo
      note
      isCurrentlySuspended
      suspensions {
        whenSuspendedFrom
        whenSuspendedTo
      }
    }
    ...AgentHistory_agent_1bayFN @include(if: $canReadHistory)
    ...AgentUsersList_agent
    ...CreateAgentTask_agent
    ...RequestToExplainCommissionCuts_agent
  }
  user {
    id
    mobile
  }
}

fragment AgentTransaction_agentUser on AgentUser {
  user {
    id
  }
  agent {
    id
    name
    floatWallet {
      balance
      id
    }
  }
}

fragment AgentUsersList_agent on Agent {
  principal {
    id
  }
  agentUsers {
    isActive
    canLogin
    user {
      id
      contactMobile
      name
    }
    agentAppVersion {
      appType
      string
      isUpToDate
    }
  }
}

fragment CreateAgentAssistant_agentUser on AgentUser {
  agent {
    ufid
    id
  }
}

fragment CreateAgentTask_agent on Agent {
  id
  ufid
  name
  territoryLeads {
    id
    name
  }
}

fragment ReportAgentIssue_agentUser on AgentUser {
  agent {
    ufid
    name
    trainingTopics {
      type
      displayName
    }
    possibleIssueTypes {
      type
      displayName
      displayGroupName
    }
    principal {
      id
    }
    agentUsers {
      isActive
      user {
        id
        contactMobile
        name
      }
    }
    id
  }
}

fragment ReportUserComplaint_agentUser on AgentUser {
  agent {
    ufid
    name
    possibleIssueTypes {
      type
      displayName
      displayGroupName
    }
    id
  }
}

fragment RequestToExplainCommissionCuts_agent on Agent {
  id
  ufid
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atx"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadBalance"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadHistory"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeCancelled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "agentId",
    "variableName": "agentId"
  },
  {
    "kind": "Variable",
    "name": "agentTransaction",
    "variableName": "atx"
  },
  {
    "kind": "Variable",
    "name": "agentUserId",
    "variableName": "userId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "includeCancelled",
  "variableName": "includeCancelled"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ufid",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobile",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOnList",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "whenUpdated",
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v20 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v21 = [
  (v8/*: any*/),
  {
    "kind": "Literal",
    "name": "includePending",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "last",
    "value": 30
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenEntered",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCancelled",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPending",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentTransactionId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeposit",
  "storageKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScamInvestigationFields",
      "kind": "LinkedField",
      "name": "scamInvestigationFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceModel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userInterface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agentMobile",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SupportHistoryEntry",
  "abstractKey": "__isSupportHistoryEntry"
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transferId",
      "storageKey": null
    }
  ],
  "type": "TransferSentEntry",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentTransactionRebalanceDepositMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "RebalanceDeposit",
        "kind": "LinkedField",
        "name": "rebalanceDeposit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentTransaction",
            "kind": "LinkedField",
            "name": "agentTransaction",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentUser",
                "kind": "LinkedField",
                "name": "agentUser",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "canReadBalance",
                        "variableName": "canReadBalance"
                      },
                      {
                        "kind": "Variable",
                        "name": "canReadHistory",
                        "variableName": "canReadHistory"
                      },
                      (v8/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "AgentTab_agentUser"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentTransactionRebalanceDepositMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "RebalanceDeposit",
        "kind": "LinkedField",
        "name": "rebalanceDeposit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentTransaction",
            "kind": "LinkedField",
            "name": "agentTransaction",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentUser",
                "kind": "LinkedField",
                "name": "agentUser",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentTrainingTopicEntry",
                        "kind": "LinkedField",
                        "name": "trainingTopics",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentIssueEntry",
                        "kind": "LinkedField",
                        "name": "possibleIssueTypes",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayGroupName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "principal",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentUser",
                        "kind": "LinkedField",
                        "name": "agentUsers",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contactMobile",
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canLogin",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AppVersion",
                            "kind": "LinkedField",
                            "name": "agentAppVersion",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "appType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "string",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isUpToDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Wallet",
                        "kind": "LinkedField",
                        "name": "floatWallet",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partnerOrg",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "photoEditUrl",
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subcity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "region",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isReported",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isCompliant",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "whenTerminated",
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commissionStructureName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commissionUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentGamingListEntry",
                        "kind": "LinkedField",
                        "name": "agentOnAgentGamingWatchlist",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentGamingListEntry",
                        "kind": "LinkedField",
                        "name": "agentOnAgentGamingWhitelist",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "format",
                            "value": "LONG"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "openingHoursDisplay",
                        "storageKey": "openingHoursDisplay(format:\"LONG\")"
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recoveryBalance",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "limitBalMin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentOverdraftOffer",
                        "kind": "LinkedField",
                        "name": "overdraftOffer",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "subAgents",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "managedByAgent",
                        "plural": false,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "rebalanceNetworkHeadAgent",
                        "plural": false,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Coordinates",
                        "kind": "LinkedField",
                        "name": "coords",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lng",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lat",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentRebalanceLimit",
                        "kind": "LinkedField",
                        "name": "activeRebalanceLimit",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rebalanceLimit",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whenActiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whenActiveTo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "note",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCurrentlySuspended",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgentRebalanceLimitSuspension",
                            "kind": "LinkedField",
                            "name": "suspensions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "whenSuspendedFrom",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "whenSuspendedTo",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StaffMember",
                        "kind": "LinkedField",
                        "name": "territoryLeads",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "canReadHistory",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v21/*: any*/),
                            "concreteType": "AgentHistoryConnection",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AgentHistoryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AgentDailySummary",
                                    "kind": "LinkedField",
                                    "name": "dailySummaries",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "whenDayEnded",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "date",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "totalCommission",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dailyAward",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numSignups",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "absoluteTransactionVolume",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "effectiveTransactionVolume",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v7/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isHistoryEntry"
                                      },
                                      (v25/*: any*/),
                                      (v14/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v28/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "composingEntries",
                                            "plural": true,
                                            "selections": [
                                              (v22/*: any*/),
                                              (v7/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v27/*: any*/),
                                              (v24/*: any*/),
                                              (v23/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v29/*: any*/)
                                                ],
                                                "type": "AgentTransactionEntry",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v16/*: any*/),
                                          (v29/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "customerName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "customerMobile",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maybeTerminatedCustomerMobile",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "agentId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "agentName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "agentUfid",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "agentUserName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "subagentUfid",
                                            "storageKey": null
                                          },
                                          (v12/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isBusinessWalletAtx",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "merchantUfid",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "merchantId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "walletAgentUfid",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "walletAgentId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TicketShortInfo",
                                            "kind": "LinkedField",
                                            "name": "relatedTicket",
                                            "plural": false,
                                            "selections": [
                                              (v19/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "slackMessageUrl",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScamReportTicket",
                                            "kind": "LinkedField",
                                            "name": "scamReports",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "whenOpened",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "whenResolved",
                                                "storageKey": null
                                              },
                                              (v19/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "transactionIds",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v30/*: any*/),
                                              (v31/*: any*/)
                                            ],
                                            "type": "HistoryEntry",
                                            "abstractKey": "__isHistoryEntry"
                                          }
                                        ],
                                        "type": "AgentTransactionEntry",
                                        "abstractKey": null
                                      },
                                      (v30/*: any*/),
                                      (v31/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "startCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v21/*: any*/),
                            "filters": [
                              "around",
                              "when",
                              "includePending",
                              "includeCancelled"
                            ],
                            "handle": "connection",
                            "key": "AgentHistory_history",
                            "kind": "LinkedHandle",
                            "name": "history"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3db4dfcdbd2e3c9a5f512522b0b7dfcc",
    "id": null,
    "metadata": {},
    "name": "AgentTransactionRebalanceDepositMutation",
    "operationKind": "mutation",
    "text": "mutation AgentTransactionRebalanceDepositMutation(\n  $atx: AgentTransactionInput!\n  $userId: ID!\n  $agentId: ID!\n  $canReadBalance: Boolean!\n  $canReadHistory: Boolean!\n  $includeCancelled: Boolean!\n) {\n  rebalanceDeposit(agentTransaction: $atx, agentUserId: $userId, agentId: $agentId) {\n    agentTransaction {\n      id\n      agentUser {\n        ...AgentTab_agentUser_4ErKPv\n      }\n    }\n  }\n}\n\nfragment AgentHistoryAtxEntry_tx on AgentTransactionEntry {\n  agentTransactionId\n  currency\n  isDeposit\n  amount\n  customerName\n  customerMobile\n  maybeTerminatedCustomerMobile\n  agentId\n  agentName\n  agentUfid\n  agentUserName\n  subagentId\n  subagentName\n  subagentUfid\n  type\n  isBusinessWalletAtx\n  merchantUfid\n  merchantId\n  walletAgentUfid\n  walletAgentId\n  isCancelled\n  composingEntries {\n    __typename\n    amount\n    summary\n    isPending\n    isCancelled\n    whenEntered\n    ... on AgentTransactionEntry {\n      agentTransactionId\n      isDeposit\n    }\n    id\n  }\n  relatedTicket {\n    status\n    slackMessageUrl\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...AgentHistoryEntry_entry\n}\n\nfragment AgentHistoryEntryDelegate_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  __typename\n  ...AgentHistoryEntry_entry\n  ...AgentHistoryAtxEntry_tx\n}\n\nfragment AgentHistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  id\n  whenEntered\n  amount\n  balance\n  summary\n  isPending\n  isCancelled\n  ... on SupportHistoryEntry {\n    __isSupportHistoryEntry: __typename\n    scamInvestigationFields {\n      deviceId\n      deviceModel\n      deviceName\n      userInterface\n      agentMobile\n    }\n  }\n  ... on AgentTransactionEntry {\n    agentTransactionId\n  }\n  ... on TransferSentEntry {\n    transferId\n  }\n}\n\nfragment AgentHistorySummary_summary on AgentDailySummary {\n  date\n  whenDayEnded\n  dailyAward\n  numSignups\n  absoluteTransactionVolume\n  effectiveTransactionVolume\n  totalCommission\n}\n\nfragment AgentHistory_agent_1bayFN on Agent {\n  id\n  history(last: 30, includePending: true, includeCancelled: $includeCancelled) {\n    edges {\n      dailySummaries {\n        whenDayEnded\n        date\n        totalCommission\n        ...AgentHistorySummary_summary\n      }\n      node {\n        __typename\n        id\n        whenEntered\n        isCancelled\n        ... on AgentTransactionEntry {\n          agentTransactionId\n          composingEntries {\n            __typename\n            ... on AgentTransactionEntry {\n              agentTransactionId\n            }\n            id\n          }\n        }\n        ...AgentHistoryEntryDelegate_entry\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      hasNextPage\n      startCursor\n      endCursor\n    }\n  }\n}\n\nfragment AgentTab_agentUser_4ErKPv on AgentUser {\n  isActive\n  ...ReportAgentIssue_agentUser\n  ...ReportUserComplaint_agentUser\n  ...AgentTransaction_agentUser\n  ...CreateAgentAssistant_agentUser\n  agent {\n    id\n    ufid\n    name\n    city\n    subcity\n    region\n    isActive\n    isReported\n    isCompliant\n    whenTerminated\n    currency\n    commissionStructureName\n    commissionUrl\n    principal {\n      id\n    }\n    agentOnAgentGamingWatchlist {\n      isOnList\n      whenUpdated\n    }\n    agentOnAgentGamingWhitelist {\n      isOnList\n      whenUpdated\n    }\n    openingHoursDisplay(format: LONG)\n    agentType\n    recoveryBalance\n    limitBalMin\n    overdraftOffer {\n      status\n      id\n    }\n    subAgents {\n      id\n      ufid\n      name\n      agentType\n    }\n    managedByAgent {\n      id\n      ufid\n      name\n    }\n    rebalanceNetworkHeadAgent {\n      id\n      ufid\n      name\n    }\n    floatWallet {\n      partnerOrg\n      photoEditUrl\n      id\n      balance @include(if: $canReadBalance)\n      mobile\n      name\n    }\n    coords {\n      lng\n      lat\n    }\n    activeRebalanceLimit {\n      rebalanceLimit\n      whenActiveFrom\n      whenActiveTo\n      note\n      isCurrentlySuspended\n      suspensions {\n        whenSuspendedFrom\n        whenSuspendedTo\n      }\n    }\n    ...AgentHistory_agent_1bayFN @include(if: $canReadHistory)\n    ...AgentUsersList_agent\n    ...CreateAgentTask_agent\n    ...RequestToExplainCommissionCuts_agent\n  }\n  user {\n    id\n    mobile\n  }\n}\n\nfragment AgentTransaction_agentUser on AgentUser {\n  user {\n    id\n  }\n  agent {\n    id\n    name\n    floatWallet {\n      balance\n      id\n    }\n  }\n}\n\nfragment AgentUsersList_agent on Agent {\n  principal {\n    id\n  }\n  agentUsers {\n    isActive\n    canLogin\n    user {\n      id\n      contactMobile\n      name\n    }\n    agentAppVersion {\n      appType\n      string\n      isUpToDate\n    }\n  }\n}\n\nfragment CreateAgentAssistant_agentUser on AgentUser {\n  agent {\n    ufid\n    id\n  }\n}\n\nfragment CreateAgentTask_agent on Agent {\n  id\n  ufid\n  name\n  territoryLeads {\n    id\n    name\n  }\n}\n\nfragment ReportAgentIssue_agentUser on AgentUser {\n  agent {\n    ufid\n    name\n    trainingTopics {\n      type\n      displayName\n    }\n    possibleIssueTypes {\n      type\n      displayName\n      displayGroupName\n    }\n    principal {\n      id\n    }\n    agentUsers {\n      isActive\n      user {\n        id\n        contactMobile\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment ReportUserComplaint_agentUser on AgentUser {\n  agent {\n    ufid\n    name\n    possibleIssueTypes {\n      type\n      displayName\n      displayGroupName\n    }\n    id\n  }\n}\n\nfragment RequestToExplainCommissionCuts_agent on Agent {\n  id\n  ufid\n}\n"
  }
};
})();
(node as any).hash = '08bc5052b407953bc0351e60c25c86c8';
export default node;
